// extracted by mini-css-extract-plugin
export default {"root":"i3IJGw"};